module.exports = __webpack_public_path__ + "img/title.1c308836.png";